import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { open: { type: Boolean, default: true } }

  connect() {
    this.openValue ? this.open() : this.close()
  }

  toggle() {
    this.openValue ? this.close() : this.open()
  }

  open() {
    this.openValue = true
    this.contentTarget.classList.toggle("hidden", false)
    this.iconTarget.classList.toggle("rotate-180", true)
  }

  close() {
    this.openValue = false
    this.contentTarget.classList.toggle("hidden", true)
    this.iconTarget.classList.toggle("rotate-180", false)
  }
}
